const convertToTimestamp = (dateString: string | null): number | null => {
  if (dateString === null) {
    return null;
  }

  return new Date(dateString).getTime();
};

export default convertToTimestamp;
